"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.testsUtils = exports.Swaler = exports.handlers = exports.SwalerLevels = exports.SwalerTypes = void 0;
var getGlobal = function () { return (window != null ? window : global); };
/**
 * Swaler Enumerations
 *  - types: List of log type that can be done
 *  - levels: List of log level that can set up
 */
var SwalerTypes;
(function (SwalerTypes) {
    SwalerTypes["TRACE"] = "TRACE";
    SwalerTypes["DEBUG"] = "DEBUG";
    SwalerTypes["INFO"] = "INFO";
    SwalerTypes["WARN"] = "WARN";
    SwalerTypes["ERROR"] = "ERROR";
})(SwalerTypes = exports.SwalerTypes || (exports.SwalerTypes = {}));
var SwalerLevels;
(function (SwalerLevels) {
    SwalerLevels[SwalerLevels["TRACE"] = 1] = "TRACE";
    SwalerLevels[SwalerLevels["DEBUG"] = 2] = "DEBUG";
    SwalerLevels[SwalerLevels["INFO"] = 3] = "INFO";
    SwalerLevels[SwalerLevels["WARN"] = 4] = "WARN";
    SwalerLevels[SwalerLevels["ERROR"] = 5] = "ERROR";
})(SwalerLevels = exports.SwalerLevels || (exports.SwalerLevels = {}));
/**
 * Define the console function to call for each type of log
 */
exports.handlers = (_a = {},
    _a[SwalerTypes.TRACE] = function () { return getGlobal().console.trace; },
    _a[SwalerTypes.DEBUG] = function () { return getGlobal().console.debug; },
    _a[SwalerTypes.INFO] = function () { return getGlobal().console.info; },
    _a[SwalerTypes.WARN] = function () { return getGlobal().console.warn; },
    _a[SwalerTypes.ERROR] = function () { return getGlobal().console.error; },
    _a);
var defaultLevel = SwalerLevels.DEBUG;
var Swaler = /** @class */ (function () {
    function Swaler(_context, opts) {
        if (_context === void 0) { _context = null; }
        if (opts === void 0) { opts = {}; }
        this._context = _context;
        this._level = opts.level || null;
        this._logOpts = null;
    }
    Swaler.prototype.shouldLog = function (level) {
        var logOpts = this._logOpts || {};
        // Should log if ignoreLevel is set to true
        if (logOpts.ignoreLevel === true) {
            return true;
        }
        // Use the logger instance level if defined
        if (this._level != null) {
            return this._level <= level;
        }
        // Otherwise, use the global default level
        return defaultLevel <= level;
    };
    Swaler.prototype.log = function (callerArgs, type, level) {
        var handler = exports.handlers[type]();
        var handlerArgs = __spread(callerArgs);
        if (this._context != null) {
            handlerArgs = ["[" + this._context + "]"].concat(__spread(handlerArgs));
        }
        if (this.shouldLog(level) === true) {
            handler.apply(null, __spread(handlerArgs));
        }
        this._logOpts = null;
    };
    Swaler.prototype.withLogOptions = function (opts) {
        this._logOpts = opts;
        return this;
    };
    Swaler.prototype.trace = function () {
        var data = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            data[_i] = arguments[_i];
        }
        this.log(arguments, SwalerTypes.TRACE, SwalerLevels.TRACE);
    };
    Swaler.prototype.debug = function () {
        var data = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            data[_i] = arguments[_i];
        }
        this.log(arguments, SwalerTypes.DEBUG, SwalerLevels.DEBUG);
    };
    Swaler.prototype.info = function () {
        var data = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            data[_i] = arguments[_i];
        }
        this.log(arguments, SwalerTypes.INFO, SwalerLevels.INFO);
    };
    Swaler.prototype.warn = function () {
        var data = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            data[_i] = arguments[_i];
        }
        this.log(arguments, SwalerTypes.WARN, SwalerLevels.WARN);
    };
    Swaler.prototype.error = function () {
        var data = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            data[_i] = arguments[_i];
        }
        this.log(arguments, SwalerTypes.ERROR, SwalerLevels.ERROR);
    };
    Object.defineProperty(Swaler.prototype, "level", {
        get: function () {
            return this._level;
        },
        set: function (level) {
            this._level = level;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Swaler.prototype, "logOpts", {
        get: function () {
            return this._logOpts;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Swaler.prototype, "context", {
        get: function () {
            return this._context;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Swaler, "defaultLevel", {
        get: function () {
            return defaultLevel;
        },
        set: function (level) {
            defaultLevel = level;
        },
        enumerable: false,
        configurable: true
    });
    return Swaler;
}());
exports.Swaler = Swaler;
/**
 * Utils provided only for testing purposes
 */
exports.testsUtils = {
    handlers: exports.handlers,
};
